// ModernColorPanel — Modern Layout のカラーパネル (右ドック wrapper、§9.6 / §9.1).
//
// 2026-06-20 (consult 2026-06-20、共有カラーパネル抽出): カラーパネル本体は
// `presentation/color/ColorPanel` へ抽出し、**Classic / Modern 両 layout が共有**する。
// 本ファイルは Modern 右ドック向けの **薄い wrapper** に縮退した (= public props を不変に
// 保ち、ModernLayout の呼び出しをそのまま動かす)。中身 (HSV ホイール + 明度 + プレビュー +
// HEX + RGB/HSV/HSL の 4way チャンネルバー / alpha なし / controlled sync + echo 抑制) は
// 共有 ColorPanel が持つ。Modern の見た目・挙動は不変 (= ホイール軸・alpha 非操作)。
//
// 不透明度 (alpha) はここに置かない: §9.1 決定3「アルファ1個 (stroke.alpha) をツール
// プロパティに『不透明度』として出す」に合わせ、alpha 操作はツールプロパティ
// (ModernToolProperties) が唯一の操作元。本パネルは `value.alpha255` をスウォッチ透明度
// 表示にだけ使う (共有 ColorPanel の仕様)。

import { ColorPanel } from '../../color/ColorPanel.js';

export interface ModernColorPanelProps {
  /**
   * 現在の描画色 (controlled)。外部 (スポイト/パレットスロット選択/alpha 外部更新) 変更に追従する。
   * `alpha255` は **スウォッチ透明度表示専用** (= 本パネルは alpha を操作しない、§9.1)。
   */
  readonly value: { readonly rgb24: number; readonly alpha255: number };
  /** 色変更 (= pen.color)。wheel / shade / hex / 数値編集で即発火。 */
  readonly onColorChange: (rgb24: number) => void;
}

export const ModernColorPanel = ({
  value,
  onColorChange,
}: ModernColorPanelProps): React.ReactNode => (
  <ColorPanel value={value} onColorChange={onColorChange} />
);
